/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  EntityId,
  List,
  OpenAPISpecContent,
  OpenAPISpecRawContent,
  OpenAPISpecVersion,
} from "./data-contracts";

/**
 * No description
 * @tags openapi-versions
 * @name ListOpenApiSpecVersions
 * @summary List all OpenAPI spec versions
 * @request GET:/orgs/{organizationId}/openapi/{specSlug}/versions
 * @secure
 */

// @ts-ignore
export const listOpenAPISpecVersions: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** Slug of the OpenAPI specification */
    specSlug: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: OpenAPISpecVersion[];
  };
  ResponseStatusCode: 200 | 404;
} = {
  route: "/orgs/{organizationId}/openapi/{specSlug}/versions",
  method: "get",
  streaming: false,
  tags: ["openapi-versions"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags openapi-versions
 * @name GetLatestOpenApiSpecVersion
 * @summary Get the latest OpenAPI spec version
 * @request GET:/orgs/{organizationId}/openapi/{specSlug}/versions/latest
 * @secure
 */

// @ts-ignore
export const getLatestOpenAPISpecVersion: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** Slug of the OpenAPI specification */
    specSlug: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: OpenAPISpecVersion;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/orgs/{organizationId}/openapi/{specSlug}/versions/latest",
  method: "get",
  streaming: false,
  tags: ["openapi-versions"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags openapi-versions
 * @name GetLatestOpenApiSpecVersionContent
 * @summary Get the latest OpenAPI spec version content
 * @request GET:/orgs/{organizationId}/openapi/{specSlug}/versions/latest/content
 * @secure
 */

// @ts-ignore
export const getLatestOpenAPISpecVersionContent: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** Slug of the OpenAPI specification */
    specSlug: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: OpenAPISpecContent;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/orgs/{organizationId}/openapi/{specSlug}/versions/latest/content",
  method: "get",
  streaming: false,
  tags: ["openapi-versions"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags openapi-versions
 * @name GetLatestOpenApiSpecVersionContentRaw
 * @summary Get the raw content of the latest OpenAPI spec version
 * @request GET:/orgs/{organizationId}/openapi/{specSlug}/versions/latest/content/raw
 * @secure
 */

// @ts-ignore
export const getLatestOpenAPISpecVersionContentRaw: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** Slug of the OpenAPI specification */
    specSlug: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: OpenAPISpecRawContent;
  ResponseStatusCode: 200 | 404;
} = {
  route:
    "/orgs/{organizationId}/openapi/{specSlug}/versions/latest/content/raw",
  method: "get",
  streaming: false,
  tags: ["openapi-versions"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags openapi-versions
 * @name GetOpenApiSpecVersionById
 * @summary Get an OpenAPI spec version by its ID
 * @request GET:/orgs/{organizationId}/openapi/{specSlug}/versions/{versionId}
 * @secure
 */

// @ts-ignore
export const getOpenAPISpecVersionById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** Slug of the OpenAPI specification */
    specSlug: string;
    /** The unique ID of the OpenAPI specification version */
    versionId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: OpenAPISpecVersion;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/orgs/{organizationId}/openapi/{specSlug}/versions/{versionId}",
  method: "get",
  streaming: false,
  tags: ["openapi-versions"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags openapi-versions
 * @name GetOpenApiSpecVersionContentById
 * @summary Get an OpenAPI spec version content by its ID
 * @request GET:/orgs/{organizationId}/openapi/{specSlug}/versions/{versionId}/content
 * @secure
 */

// @ts-ignore
export const getOpenAPISpecVersionContentById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** Slug of the OpenAPI specification */
    specSlug: string;
    /** The unique ID of the OpenAPI specification version */
    versionId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: OpenAPISpecContent;
  ResponseStatusCode: 200 | 404;
} = {
  route:
    "/orgs/{organizationId}/openapi/{specSlug}/versions/{versionId}/content",
  method: "get",
  streaming: false,
  tags: ["openapi-versions"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};
